import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinkharadi() {



  const cardData = {
"keyword": "Urbania on Rent in Kharadi",

"headingDescription":
  "Aaradhya Travels provides reliable Urbania on Rent in Kharadi for corporate travel, IT employee transportation, airport transfers, weddings, family trips, outstation tours, and luxury group travel requirements. Our Force Urbania vehicles come with premium pushback seating, air-conditioning, spacious interiors, luggage space, charging points, music systems, and professional drivers familiar with Kharadi IT hubs and Pune city routes. We ensure safe, comfortable, and punctual transportation with doorstep pickup services across Kharadi and nearby Pune areas.",

"topPlaces": [

{
"title": "Pawna Lake",
"description":
"Pawna Lake is a scenic lakeside destination near Lonavala known for camping, sunset views, bonfire nights, and peaceful surroundings. It is highly popular among group travelers and weekend tourists from Pune."
},
  {
"title": "Khandala",
"description":
"Khandala is a popular hill station near Pune known for its misty mountains, scenic viewpoints, waterfalls, and pleasant weather. It is a favorite weekend getaway for families and group travelers using buses and Tempo Travellers for comfortable short road trips."
},
{
"title": "Lonavala",
"description":
"Lonavala is one of the most famous hill stations near Pune known for green valleys, Tiger Point, Bhushi Dam, caves, and monsoon beauty. It is widely visited by family groups, corporate teams, and friends for short and comfortable bus trips."
},
{
"title": "Lavasa",
"description":
"Lavasa is a planned hill city near Pune known for lakeside promenade, colorful buildings, cafes, and peaceful environment. It is ideal for relaxed group outings, corporate trips, and family leisure travel."
},

{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station known for toy train rides, viewpoints, and cool weather. It is perfect for peaceful group travel and family sightseeing tours from Pune."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a calm hill station known for Arthur Lake, Randha Falls, and natural beauty. It is a perfect relaxing destination for group tours and weekend trips from Pune."
},
{
"title": "Kamshet",
"description":
"Kamshet is a scenic hill region near Pune famous for paragliding, green valleys, and peaceful landscapes. It is popular among adventure lovers and group travelers looking for short trips."
},
{
"title": "Mulshi",
"description":
"Mulshi is a beautiful lake and dam destination near Pune surrounded by hills and greenery. It is a popular picnic and one-day group travel destination for families and corporate outings."
},
{
"title": "Tamhini Ghat",
"description":
"Tamhini Ghat is a scenic mountain pass known for waterfalls, fog, and lush greenery during monsoon. It is a favorite short road trip destination for group travelers from Pune."
},
{
"title": "Aamby Valley",
"description":
"Aamby Valley is a luxury hill township near Lonavala known for scenic landscapes, lakes, and premium resorts. It is popular for corporate trips, luxury group outings, and weekend leisure travel."
}
],



services: [
  {
    name: "Urbania on Rent in Kharadi",
    description: "Urbania on rent in Kharadi service provides luxury transportation for corporate travel, family vacations, airport transfers, sightseeing tours, and group travel requirements. Spacious seating and modern interiors ensure smooth journeys suitable for local and outstation travel. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Kharadi Pune. Flexible booking options allow convenient Urbania rental reservations."
  },
  {
    name: "13 Seater Urbania on Rent in Kharadi",
    description: "13 seater Urbania on rent in Kharadi service offers premium transportation for family outings, airport transfers, office travel, and tourist journeys. Comfortable seating and luggage space ensure pleasant journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and commercial hubs across Kharadi Pune. Flexible booking options allow convenient 13 seater Urbania reservations."
  },
  {
    name: "17 Seater Urbania on Rent in Kharadi",
    description: "17 seater Urbania on rent in Kharadi service provides spacious transportation for weddings, business meetings, office outings, and family group travel. Premium interiors and smooth travel ensure comfortable journeys suitable for medium-sized passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Kharadi Pune. Flexible booking options allow convenient 17 seater Urbania reservations."
  },
  {
    name: "Urbania Hire in Kharadi Pune",
    description: "Urbania hire in Kharadi Pune service offers reliable transportation for airport transfers, sightseeing tours, family vacations, and executive travel requirements. Spacious seating and luggage space ensure smooth journeys suitable for local and outstation transportation. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Kharadi Pune. Flexible booking options allow convenient Urbania hire reservations."
  },
  {
    name: "Urbania Booking in Kharadi",
    description: "Urbania booking in Kharadi service provides dependable transportation for weddings, family trips, office staff travel, and tourist journeys. Comfortable seating and modern interiors ensure pleasant travel experiences suitable for local and long-distance passenger movement. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Kharadi Pune. Flexible booking options allow convenient Urbania booking reservations."
  },
  {
    name: "Luxury Urbania on Rent in Kharadi",
    description: "Luxury Urbania on rent in Kharadi service provides premium transportation with elegant interiors and spacious seating for weddings, corporate travel, airport transfers, and family vacations. Smooth highway travel ensures pleasant journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Kharadi Pune. Flexible booking options allow convenient luxury Urbania reservations."
  },
  {
    name: "Urbania Rental Service in Kharadi",
    description: "Urbania rental service in Kharadi provides spacious transportation for educational tours, family outings, corporate travel, and sightseeing trips. Comfortable seating and smooth travel ensure pleasant journeys suitable for local and outstation transportation requirements. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, schools, hotels, and offices across Kharadi Pune. Flexible booking options allow convenient Urbania rental service reservations."
  },
  {
    name: "AC Urbania on Rent in Kharadi",
    description: "AC Urbania on rent in Kharadi service offers premium air-conditioned transportation for weddings, corporate travel, family outings, and airport transfers. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Kharadi Pune. Flexible booking options allow convenient AC Urbania reservations."
  },
  {
    name: "Non-AC Urbania on Rent in Kharadi",
    description: "Non-AC Urbania on rent in Kharadi service provides affordable transportation for educational tours, office travel, sightseeing journeys, and family outings. Spacious seating and luggage space ensure comfortable journeys suitable for budget-friendly local and outstation travel requirements. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Kharadi Pune. Flexible booking options allow convenient non-AC Urbania reservations."
  },
  {
    name: "Urbania on Rent for Outstation in Kharadi",
    description: "Urbania on rent for outstation in Kharadi service provides premium long-distance transportation for Goa tours, hill station vacations, pilgrimage journeys, and family trips. Spacious seating and smooth highway travel ensure comfortable journeys suitable for all passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Kharadi Pune. Flexible booking options allow convenient outstation Urbania reservations."
  },
  {
    name: "Urbania for Corporate Events in Kharadi",
    description: "Urbania for corporate events in Kharadi service provides luxury transportation for office meetings, conferences, employee outings, exhibitions, and executive travel requirements. Spacious interiors and premium seating ensure pleasant journeys suitable for business passenger groups. Professional chauffeurs ensure punctual transportation and dependable pickup services throughout the route. Pickup services are available from offices, IT parks, hotels, and airports across Kharadi Pune. Flexible booking options allow convenient corporate event Urbania reservations."
  },
  {
    name: "Urbania for Airport Pickup Kharadi",
    description: "Urbania for airport pickup Kharadi service provides dependable transportation for airport transfers, tourist groups, business travelers, and family travel requirements. Spacious seating and luggage space ensure comfortable journeys suitable for local and outstation airport transportation. Professional chauffeurs ensure timely airport pickups and safe driving services throughout the route. Pickup services are available from Pune Airport, homes, offices, hotels, and residential areas across Kharadi Pune. Flexible booking options allow convenient airport Urbania reservations."
  },
  {
    name: "Urbania for Wedding Function Kharadi",
    description: "Urbania for wedding function Kharadi service offers elegant transportation for marriage ceremonies, bridal travel, guest transportation, and family functions. Spacious seating and premium interiors ensure comfortable journeys suitable for wedding celebrations and event transportation. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding itinerary. Pickup services are available from homes, banquet halls, hotels, and residential areas across Kharadi Pune. Flexible booking options allow convenient wedding Urbania reservations."
  },
  {
    name: "Best Urbania Rental in Kharadi",
    description: "Best Urbania rental in Kharadi service provides premium transportation for sightseeing tours, family vacations, office travel, airport pickups, and tourist journeys. Spacious seating and smooth travel ensure pleasant journeys suitable for local and outstation transportation requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Kharadi Pune. Flexible booking options allow convenient Urbania rental reservations."
  },
  {
    name: "Urbania Tempo Traveller in Kharadi",
    description: "Urbania tempo traveller in Kharadi service offers spacious transportation for family group travel, office outings, weddings, and tourist journeys. Comfortable seating and luggage capacity ensure smooth journeys suitable for medium and large passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Kharadi Pune. Flexible booking options allow convenient Urbania tempo traveller reservations."
  },
  {
    name: "Urbania on Rent Near EON IT Park",
    description: "Urbania on rent near EON IT Park service provides dependable transportation for IT employees, office commute, conferences, airport transfers, and executive travel requirements. Spacious seating and modern interiors ensure smooth journeys suitable for corporate passenger groups. Professional chauffeurs ensure reliable transportation and punctual pickup services throughout the route. Pickup services are available from EON IT Park, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient EON IT Park Urbania reservations."
  },
  {
    name: "Urbania on Rent Near World Trade Center Kharadi",
    description: "Urbania on rent near World Trade Center Kharadi service offers reliable transportation for business meetings, office travel, conferences, airport transfers, and executive journeys. Spacious interiors and comfortable seating ensure pleasant journeys suitable for corporate passengers and family groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from offices, hotels, airports, and business hubs across Kharadi Pune. Flexible booking options allow convenient World Trade Center Urbania reservations."
  },
  {
    name: "Urbania on Rent in Kharadi for Family Trip",
    description: "Urbania on rent in Kharadi for family trip service provides dependable transportation for holiday vacations, sightseeing tours, pilgrimage journeys, and family outings. Spacious seating and comfortable interiors ensure pleasant journeys suitable for local and outstation family group travel. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Kharadi Pune. Flexible booking options allow convenient family trip Urbania reservations."
  },
  {
    name: "Urbania on Rent for Group Travel in Kharadi",
    description: "Urbania on rent for group travel in Kharadi service provides spacious transportation for educational tours, sightseeing journeys, office outings, family vacations, and tourist travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for medium-sized passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Kharadi Pune. Flexible booking options allow convenient group travel Urbania reservations."
  },
  {
    name: "Affordable Urbania on Rent in Kharadi",
    description: "Affordable Urbania on rent in Kharadi service provides economical transportation for family outings, office travel, sightseeing journeys, and local or outstation group trips. Spacious seating and luggage space ensure comfortable travel experiences suitable for budget-friendly transportation requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Kharadi Pune. Flexible booking options allow convenient affordable Urbania reservations."
  },
  {
    name: "Urbania Traveller Kharadi",
    description: "Urbania traveller Kharadi service provides luxury transportation for airport transfers, weddings, sightseeing tours, corporate travel, and family vacations. Spacious seating and premium interiors ensure comfortable journeys suitable for local and outstation travel requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, airports, and residential areas across Kharadi Pune. Flexible booking options allow convenient Urbania traveller reservations."
  },
  {
    name: "Urbania on Rent Viman Nagar",
    description: "Urbania on rent Viman Nagar service offers premium transportation for airport pickups, business travel, sightseeing tours, and family group journeys. Comfortable seating and luggage capacity ensure smooth journeys suitable for local and long-distance travel requirements. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Viman Nagar Pune. Flexible booking options allow convenient Viman Nagar Urbania reservations."
  }
],

tableData: [
  ["Urbania on Rent in Kharadi", "13 Seater Urbania on Rent in Kharadi"],
  ["17 Seater Urbania on Rent in Kharadi", "Urbania Hire in Kharadi Pune"],
  ["Urbania Booking in Kharadi", "Luxury Urbania on Rent in Kharadi"],
  ["Urbania Rental Service in Kharadi", "AC Urbania on Rent in Kharadi"],
  ["Non-AC Urbania on Rent in Kharadi", "Urbania on Rent for Outstation in Kharadi"],
  ["Urbania for Corporate Events in Kharadi", "Urbania for Airport Pickup Kharadi"],
  ["Urbania for Wedding Function Kharadi", "Best Urbania Rental in Kharadi"],
  ["Urbania Tempo Traveller in Kharadi", "Urbania on Rent Near EON IT Park"],
  ["Urbania on Rent Near World Trade Center Kharadi", "Urbania on Rent in Kharadi for Family Trip"],
  ["Urbania on Rent for Group Travel in Kharadi", "Affordable Urbania on Rent in Kharadi"],
  ["Urbania Traveller Kharadi", "Urbania on Rent Viman Nagar"]
],





 whychoose: [
      {
        WhyChooseheading: "Reliable Urbania on Rent in Kharadi",
        WhyChoosedescription: "Aaradhya Travels provides reliable Urbania rental service in Kharadi with luxury vehicles, professional drivers, and smooth travel arrangements for family trips, corporate tours, weddings, and group travel."
      },
      {
        WhyChooseheading: "Affordable Luxury Urbania Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Urbania on rent in Kharadi with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Urbania Booking Service",
        WhyChoosedescription: "Our Force Urbania rental service in Kharadi operates 24 hours for airport transfers, weddings, outstation tours, pilgrimage trips, corporate outings, and luxury group travel."
      },
      {
        WhyChooseheading: "Comfortable AC Luxury Urbania Vehicles",
        WhyChoosedescription: "All Urbania vehicles provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for premium and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, pilgrimage journeys, sightseeing travel, and multi-day outstation packages according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Urbania Options",
        WhyChoosedescription: "Customers can choose from 9 seater, 13 seater, 14 seater, and 17 seater luxury Force Urbania vehicles suitable for family vacations, corporate groups, wedding guests, and tourist travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Kharadi & Nearby Areas",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Kharadi, EON IT Park, Viman Nagar, Wagholi, Hadapsar, Magarpatta, Pune Airport, hotels, and nearby Pune locations for hassle-free travel."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Outstation Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation luxury group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Urbania on rent in Kharadi?", answer: "Urbania on rent in Kharadi provides luxury group transportation using premium Force Urbania vehicles for family tours, corporate travel, weddings, and outstation journeys." },
    { question: "Is Urbania booking available 24 hours in Kharadi?", answer: "Yes, Aaradhya Travels provides 24/7 Force Urbania rental service in Kharadi." },
    { question: "Which seating options are available in Urbania?", answer: "Aaradhya Travels offers 9 seater, 13 seater, 14 seater, and 17 seater Force Urbania vehicles for different group travel requirements." },
    { question: "Can I book Urbania for outstation trips from Kharadi?", answer: "Yes, customers can book Force Urbania for hill stations, pilgrimage tours, holiday trips, destination weddings, and outstation travel from Kharadi Pune." },
    { question: "Do you provide Urbania for corporate events in Kharadi?", answer: "Yes, Aaradhya Travels provides Force Urbania service for office outings, conferences, employee transport, and corporate travel." },
    { question: "Are all Urbania vehicles air-conditioned?", answer: "Yes, all Force Urbania vehicles are fully air-conditioned and maintained for comfortable luxury travel." },
    { question: "Can I book Urbania online in Kharadi?", answer: "Yes, customers can easily book Force Urbania rental service online or through phone booking." },
    { question: "Do you provide Pune Airport pickup and drop service?", answer: "Yes, Aaradhya Travels provides airport pickup and drop service using luxury Force Urbania vehicles." },
    { question: "Are Urbania rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Urbania rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Saurabh Deshmukh",
    feedback:
      "Group travel from Kharadi became very smooth with Aaradhya Travels providing a Force Urbania. The ride felt premium and comfortable, and everyone could travel together without any hassle.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "Aaradhya Travels arranged a Force Urbania on rent in Kharadi for our family outing, and everything was managed very well. The vehicle was clean, spacious, and the journey was enjoyable for all.",
    rating: 5
  }
];


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];
















  return (
    <div>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/88.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaonrentinkharadi ;